<ng-ut-results-map
  *ngIf="(store$ | async) as store"
  [filtersConfigs]="filtersConfigs"
  [loading]="store.loading"
  [shipments]="store.mapShipments"
  [traces]="store.mapTraces"
  (makeAdvanceSearch)="makeAdvanceSearch($event)"
  (viewPermit)="viewPermit($event)"
  (viewTrainConsist)="viewTrainConsist($event)"
  (viewRoute)="viewRoute($event)"
  (clearRoute)="clearRoute()"
></ng-ut-results-map>
